import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faGamepad,
  faHeadphones,
  faMicrochip,
  faMobileScreen,
  faShieldHalved,
  faStar
} from '@fortawesome/free-solid-svg-icons';

const categories = [
  { title: 'Consoles', copy: 'PlayStation, Xbox, Nintendo and retro', icon: faGamepad, to: '/consoles' },
  { title: 'Gaming PCs', copy: 'High-performance rigs, checked in store', icon: faMicrochip, to: '/pc-building' },
  { title: 'Games', copy: 'New releases and pre-owned favourites', icon: faShieldHalved, to: '/games' },
  { title: 'Tech', copy: 'Phones, laptops, headsets and accessories', icon: faHeadphones, to: '/tech' }
];

const arrivals = [
  { image: '/images/2026/categories/consoles/detail-1.png', title: 'Console bundles', price: 'Current and retro', label: 'Consoles' },
  { image: '/images/2026/categories/games/detail-2.png', title: 'Pre-owned games', price: 'Fresh stock', label: 'Games' },
  { image: '/images/2026/categories/tech/detail-3.png', title: 'Gaming PCs', price: 'Built and tested', label: 'PC Gaming' },
  { image: '/images/2026/categories/tech/detail-1.png', title: 'Phones and tech', price: 'Upgrade ready', label: 'Tech' },
  { image: '/images/2026/categories/trade-in/detail-2.png', title: 'Trade-in upgrades', price: 'Cash or credit', label: 'Trade In' }
];

const Home = () => (
  <div className="arcade-home">
    <section className="arcade-hero" aria-labelledby="home-title">
      <div className="hero-stars" aria-hidden="true" />
      <div className="corner corner-tl" aria-hidden="true" />
      <div className="corner corner-tr" aria-hidden="true" />
      <div className="corner corner-bl" aria-hidden="true" />
      <div className="corner corner-br" aria-hidden="true" />

      <div className="player-panel player-one">
        <p className="pixel-label">Player 1:</p>
        <h1 id="home-title"><span className="sr-only">Game On Cosham gaming shop: </span>Shop</h1>
        <p>New gear. Classic vibes. Next level.</p>
        <a className="pixel-button" href="https://www.ebay.co.uk/str/gameoncoham" target="_blank" rel="noopener noreferrer">
          Browse eBay store <FontAwesomeIcon icon={faArrowRight} />
        </a>
      </div>

      <div className="hero-ship-wrap" aria-hidden="true">
        <span className="ship-speed-line line-one" />
        <span className="ship-speed-line line-two" />
        <span className="ship-speed-line line-three" />
        <img src="/images/2026/arcade/hero-ship.png" alt="" />
      </div>

      <div className="player-panel player-two">
        <p className="pixel-label">Player 2:</p>
        <h2>Trade</h2>
        <p>Turn your tech into cash or credit.</p>
        <Link className="pixel-button" to="/trade-in">
          Trade in <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>

      <div className="hero-lives" aria-hidden="true">+ + +</div>
      <div className="hero-score"><span>Hi-score</span><strong>1985 000</strong></div>
    </section>

    <section className="arcade-section category-select" aria-labelledby="category-title">
      <header className="arcade-heading">
        <span aria-hidden="true" />
        <h2 id="category-title">Select Category</h2>
        <span aria-hidden="true" />
      </header>
      <div className="arcade-category-grid">
        {categories.map((category) => (
          <Link className="arcade-category" to={category.to} key={category.title}>
            <FontAwesomeIcon icon={category.icon} />
            <div>
              <h3>{category.title}</h3>
              <p>{category.copy}</p>
            </div>
            <FontAwesomeIcon className="category-arrow" icon={faArrowRight} />
          </Link>
        ))}
      </div>
    </section>

    <section className="arcade-section arrivals-section" aria-labelledby="arrivals-title">
      <div className="section-title-row">
        <div>
          <p className="pixel-kicker">Fresh drops</p>
          <h2 id="arrivals-title">New Arrivals</h2>
        </div>
        <a href="https://www.ebay.co.uk/str/gameoncoham" target="_blank" rel="noopener noreferrer">View all <FontAwesomeIcon icon={faArrowRight} /></a>
      </div>
      <div className="arrival-grid">
        {arrivals.map((item) => (
          <article className="arrival-card" key={item.title}>
            <div className="arrival-image">
              <img src={item.image} alt={`${item.title} at Game On Cosham`} loading="lazy" decoding="async" />
            </div>
            <div className="arrival-copy">
              <p>{item.label}</p>
              <h3>{item.title}</h3>
              <strong>{item.price}</strong>
            </div>
          </article>
        ))}
      </div>
    </section>

    <section className="arcade-section feature-mission" aria-labelledby="mission-title">
      <div className="mission-art">
        <img
          src="/images/2026/pc-building/home-feature.webp"
          alt="Pixel art gaming PC being assembled in the Game On workshop"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="mission-copy">
        <p className="pixel-kicker">Bonus Stage</p>
        <h2 id="mission-title">Gaming PCs built to win</h2>
        <p>High-performance systems, practical upgrade advice and every machine checked before it reaches the shop floor.</p>
        <ul>
          <li><FontAwesomeIcon icon={faStar} /> Performance matched to your games</li>
          <li><FontAwesomeIcon icon={faShieldHalved} /> Built and tested before sale</li>
          <li><FontAwesomeIcon icon={faMobileScreen} /> Local support when you need it</li>
        </ul>
        <Link className="pixel-button" to="/pc-building">View gaming PCs <FontAwesomeIcon icon={faArrowRight} /></Link>
      </div>
    </section>
  </div>
);

export default Home;
